export default "__VITE_ASSET__2cc4a551__"